import CreditsRowMobile from './CreditsRowMobile';

export default CreditsRowMobile;
